// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zHo1","inner":"Footer_inner__QLgRn"};